import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberArray',
})
export class NumberArrayPipe implements PipeTransform {
  transform(value: number): number[] {
    const result = [];
    for (let i = 1; i <= value; i++) {
      result.push(i);
    }
    return result;
  }
}
